console.log('aaaa')

const common = {
  state: {
    projectId: sessionStorage.getItem('projectId') ? parseInt(sessionStorage.getItem('projectId')) : '',
    projectInfo: sessionStorage.getItem('projectInfo') ? JSON.parse(sessionStorage.getItem('projectInfo')) : {},
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    userId: '',
    // permissionList: sessionStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : [] // 权限
    permissionList: sessionStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : [], // 开发使用,
    isCollapse: (sessionStorage.getItem('isCollapse') === '1') || false,
    accident: [], // 事故模拟数据
    chemicalList: [], // 化学品列表
    alarmData: {}, // 报警推送信息
    isProjectUser: null, // 是否企业用户
    isAddCompany: 1, // 是否添加或编辑了企业信息
    routeTab: sessionStorage.getItem('route') ? JSON.parse(sessionStorage.getItem('route')) : [] // 路由
  },
  mutations: {
    SET_ROUTE_TAB: (state, routeTab) => {
      state.routeTab = routeTab
      sessionStorage.setItem('route', JSON.stringify(routeTab))
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_ISPROJECTUSER: (state, isProjectUser) => {
      state.isProjectUser = isProjectUser
    },
    SET_CHEMICALLIST: (state, chemicalList) => {
      state.chemicalList = chemicalList
    },
    SET_IS_ADD_COMPANY: (state, isAddCompany) => {
      state.isAddCompany = isAddCompany
    },
    SET_ALARMDATA: (state, alarmData) => {
      state.alarmData = alarmData
    },
    SET_SHOPID: (state, shopId) => {
      state.shopId = shopId
    },
    SET_ACCIDENT: (state, accident) => {
      state.accident = accident
    },
    SET_PERMISSIONlIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_IS_COLLAPSE: (state, isCollapse) => {
      state.isCollapse = isCollapse
      sessionStorage.setItem('isCollapse', isCollapse ? 1 : 0)
    },
    SET_PROJECTID: (state, projectId) => {
      state.projectId = projectId
      sessionStorage.setItem('projectId', projectId)
    },
    SET_PROJECTINFO: (state, projectInfo) => {
      state.projectInfo = projectInfo
      sessionStorage.setItem('projectInfo', JSON.stringify(projectInfo))
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  actions: {
    setIsProjectUser ({ commit }, isProjectUser) {
      commit('SET_ISPROJECTUSER', isProjectUser)
    },
    setUserId ({ commit }, userId) {
      commit('SET_USERID', userId)
    },
    setRouteTab ({ commit }, routeTab) {
      commit('SET_ROUTE_TAB', routeTab)
    },
    setIsAddCompany ({ commit }, isAddCompany) {
      commit('SET_IS_ADD_COMPANY', isAddCompany)
    },
    setAlarmData ({ commit }, alarmData) {
      commit('SET_ALARMDATA', alarmData)
    },
    setChemicalList ({ commit }, chemicalList) {
      commit('SET_CHEMICALLIST', chemicalList)
    },
    setAccident ({ commit }, accident) {
      commit('SET_ACCIDENT', accident)
    },
    setPermissionList ({ commit }, permissionList) {
      commit('SET_PERMISSIONlIST', permissionList)
    },
    setProjectId ({ commit }, projectId) {
      commit('SET_PROJECTID', projectId)
    },
    setProjectInfo ({ commit }, projectInfo) {
      commit('SET_PROJECTINFO', projectInfo)
    },
    setUserInfo ({ commit }, userInfo) {
      commit('SET_USERINFO', userInfo)
    },
    setIsCollapse ({ commit }, isCollapse) {
      commit('SET_IS_COLLAPSE', isCollapse)
    }
  }
}

export default common
